import './AudioPlayer.less';
import React from 'react';
import AudioHelper from "../../../helpers/AudioHelper";


export default function AudioPlayer({audio}) {

    return <div className="audio-player">
        <audio src={AudioHelper.getUrl(audio)} controls/>
    </div>
}
